import { render, staticRenderFns } from "./PatientProfileView.vue?vue&type=template&id=505c9cee&scoped=true"
import script from "./PatientProfileView.vue?vue&type=script&lang=js"
export * from "./PatientProfileView.vue?vue&type=script&lang=js"
import style0 from "./PatientProfileView.vue?vue&type=style&index=0&id=505c9cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c9cee",
  null
  
)

export default component.exports